import { React, useState, useEffect } from "react";
import { notification, Modal, Typography, Select, Space } from "antd";
import { TagOutlined, ShopOutlined, BarcodeOutlined } from "@ant-design/icons";
import axiosInstance from "utilities/axios";

const { Text } = Typography;

const FilterModal = ({ visible, setVisible, setFilters }) => {
	const [clinics, setClinics] = useState([]);

	const [equipmentOptions, setEquipmentTypes] = useState([]);

	const mapFunc = (e) => {
		return {
			value: e,
			label: e,
		};
	};

  const categoryOptions = Array.from(
    new Set(equipmentOptions.map((e) => e.category))
  ).map(mapFunc);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const brandOptions = Array.from(
    new Set(
      equipmentOptions
        .filter((e) => e.category === selectedCategory)
        .map((e) => e.brand)
    )
  ).map(mapFunc);
  const [selectedBrand, setSelectedBrand] = useState(null);

  const modelOptions = equipmentOptions
    .filter((e) => e.brand === selectedBrand && e.category === selectedCategory)
    .map((e) => e.model)
    .map(mapFunc);

  const [selectedModel, setSelectedModel] = useState(null);

  useEffect(() => {
    function fetchEquipmentTypes() {
      axiosInstance.get("/equipment").then((result) => {
        setEquipmentTypes(result.data);
      });
    }
    fetchEquipmentTypes();
  }, []);

	useEffect(() => {
		axiosInstance
			.get("/clinics")
			.then((response) => {
				setClinics(response.data);
			})
			.catch((error) => {
				notification.error({
					message: "Error",
					description: error.message,
				});
			});
	}, []);

	return (
		<Modal
			title="Filter Calibrations"
			open={visible}
			onCancel={() => setVisible(false)}
			footer={[]}
		>
			<div style={{ marginBottom: "16px" }}>
				<Text>Clinics</Text>
				<Select
					mode="multiple"
					placeholder="Select Clinics"
					onChange={(value) => {
						setFilters((prevFilters) => ({
							...prevFilters,
							clinics: value,
						}));
					}}
					style={{ width: "100%" }}
					filterOption={(input, option) => {
						const optionData = clinics.find((clinic) => clinic.clinic === option.value);
						if (!optionData) return false;
						return (
							optionData.clinic.toLowerCase().includes(input.toLowerCase()) ||
							optionData.clinicName.toLowerCase().includes(input.toLowerCase())
						);
					}}
				>
					{clinics.map((clinic) => (
						<Select.Option key={clinic.clinic} value={clinic.clinic}>
							{clinic.clinic} - {clinic.clinicName}
						</Select.Option>
					))}
				</Select>
			</div>
			<div style={{ marginBottom: "16px" }}>
				<label>
					<Space>
						<TagOutlined /> Category
					</Space>
				</label>
				<Select
					value={selectedCategory}
					style={{ width: "100%" }}
					autoFocus
					onChange={(value) => {
						setSelectedCategory(value);
						setSelectedBrand(null);
						setSelectedModel(null);
						setFilters((prevFilters) => ({
							...prevFilters,
							category: value,
							brand: null,
							model: null,
						}));
					}}
					placeholder="Select a category"
					defaultActiveFirstOption={false}
					options={categoryOptions}
					allowClear
				/>
			</div>
			{selectedCategory && (
        <div style={{ marginBottom: "16px" }}>
          <label>
            <Space>
              <ShopOutlined /> Brand
            </Space>
          </label>
          <Select
            value={selectedBrand}
            style={{ width: "100%" }}
            onChange={(value) => {
              setSelectedBrand(value);
              setSelectedModel(null);
							setFilters((prevFilters) => ({
								...prevFilters,
								brand: value,
								model: null,
							}));
            }}
            placeholder="Select a brand"
            defaultActiveFirstOption={false}
            options={brandOptions}
			allowClear
          />
        </div>
      )}
      {selectedBrand && (
        <div>
          <label>
            <Space>
              <BarcodeOutlined /> Model
            </Space>
          </label>
          <Select
            value={selectedModel}
            style={{ width: "100%" }}
            onChange={(value) => {
              setSelectedModel(value);
							setFilters((prevFilters) => ({
								...prevFilters,
								model: value,
							}));
            }}
            placeholder="Select a model"
            defaultActiveFirstOption={false}
            showSearch
            options={modelOptions}
			allowClear
          />
        </div>
      )}
		</Modal>
	);
};

export default FilterModal;